import { GetBloqueoPeriodoContableDtoProps } from "./DTOs/GetBloqueoPeriodoContableDto"

export const BloqueoContableAdapter = (
  data: GetBloqueoPeriodoContableDtoProps
): GetBloqueoPeriodoContableDtoProps => ({
  meses: data?.meses,
})
